import { ACCEPTED_FILE_TYPES, LANGUAGES } from '@constants'
import { registerDateLocales } from '@integrations/date-setup'
import { configuration, initialize } from 'mmfintech-backend-api'
import { dateLocales } from '../integration-setup/date-locales'

initialize(import.meta.env)

registerDateLocales(dateLocales)

initialize(import.meta.env)

const settings = {
  cookieDomain: '.banky.io',
  customerServiceUrl: 'mailto:support@banky.io',
  landingPageUrl: configuration.isDevelopment()
    ? 'https://dev.banky.io/'
    : configuration.isSandbox()
      ? 'https://sandbox.banky.io/'
      : 'https://banky.io',
  languages: Object.values(LANGUAGES),
  questionnaireFileTypes: Object.values(ACCEPTED_FILE_TYPES),
  questionnaireMaxFileSize: 1024 * 1024 * 10
}

export default settings
